import 'swiper/css';
import 'swiper/css/pagination';

import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'react-i18next';
import { useGetApiV1ClientAdsQuery } from 'service/api/allApis';
import AdvertSlide from './slide';

const PremiumAdvertSlider = () => {
    const { t } = useTranslation();
    const { data, isLoading, isFetching } = useGetApiV1ClientAdsQuery({
        isPaginated: false,
        pageSize: 20,
        isPremium: true,
    });
    const loading = isFetching || isLoading;

    if (data && data.items?.length === 0) return null;

    return (
        <section className="hidden md:block mb-[50px] z-[1] relative">
            <h2 className="text-brend text-center text-[32px] leading-[44px] font-bold tracking-[3.84px]">
                {t('general.premium-adverts')}
            </h2>
            <Swiper
                loop
                pagination={{
                    clickable: true,
                }}
                speed={2000}
                modules={[Pagination, Autoplay]}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                className="md:w-[925px] lg:w-[1070px] mx-auto md:h-[500px] lg:h-[520px] mt-10 py-10 relative"
            >
                {data?.items?.map((advert) => (
                    <SwiperSlide key={advert.id}>
                        <AdvertSlide advert={advert} />
                    </SwiperSlide>
                ))}
                {loading && <AdvertSlide.Skeleton />}
            </Swiper>
        </section>
    );
};

export default PremiumAdvertSlider;
